"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Finds indexes of an array that match the predicate
 * 
 * @category Array
 * @param {array} array - The array of data to search
 * @param {function} predicate - The predicate function that returns true to include the index, false to exclude
 * @returns {array} - Array of indexes that match the predicate
 * @example
 * const array = [
 *  { firstName: 'Alba', lastName: 'Clay', age: 10 },
 *  { firstName: 'Bullock', lastName: 'Chapman', age: 30 },
 *  { firstName: 'Darla', lastName: 'Austin', age: 15 },
 * ];
 * 
 * const indexes = findIndexes(array, x => x.age < 20);
 * // => [0, 2]
 */
var _default = function _default(array, predicate) {
  var output = [];

  for (var i = 0; i < array.length; i++) {
    if (predicate(array[i])) {
      output = [].concat(_toConsumableArray(output), [i]);
    }
  }

  return output;
};

exports.default = _default;